import { Link } from "react-router-dom";
import { AdminAccountMenu } from "./AdminAccountMenu";
import { useEffect, useState } from "react";
import { CustomButton } from "../../../components/global/CustomButton";
import "./adminHeader.css"

export function AdminHeader({ sidebarDisplay, setSidebarDisplay }) {
    const [isSticky, setIsSticky] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 1) {
                setIsSticky(true)
            } else {
                setIsSticky(false)
            }
        })
    }, [])

    return (
        <div className={`admin-header d-flex justify-content-between align-items-center px-2 px-sm-4 py-2 ${isSticky ? "sticky" : ""}`}>
                <i
                    className="fa-solid fa-bars fs-4 lg-off"
                    onClick={() => setSidebarDisplay(!sidebarDisplay)}>
                </i>
                <Link to="/admin" className="website-logo lg-on">Exclusive</Link>

                <CustomButton
                    color="primary"
                    text="Main Website"
                    btnLink={true}
                    path="/"
                />

                <AdminAccountMenu />
        </div>
    )
}